document.addEventListener('alpine:init', () => {
  Alpine.data('quickAdd', () => ({
    loadingClass: '!x-animate-pulse',

    addItem(ids, elem, applyClass) {
      elem.classList.add(applyClass ?? this.loadingClass);
      let items = ids.constructor === Array ? ids : [ids];
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          'items': items.map((x) => {
            return {
              'id': x,
              'quantity': 1
            }
          })
        })
      }).then(response => {
        const cartItems = document.querySelector('cart-drawer-items');
        cartItems.onCartUpdate();
        document.querySelector('cart-drawer.drawer').classList.remove('is-empty');
        document.querySelector('#CartDrawer-Checkout')?.removeAttribute('disabled');

        var die = document.querySelector('.drawer__inner-empty');
        if (die) {die.classList.remove('drawer__inner-empty');}

        document.querySelector('cart-drawer').open();
        return response.json();
      })
        .catch((error) => {
          console.error('Error:', error);
        })
        .finally(() => {
          elem.classList.remove(applyClass ?? this.loadingClass);
        });
    }
  }))
})